<template>
  <component :is="moduleComponent" :module="loadedModule" v-if="moduleComponent"/>
</template>
<script>
  import Waterwheel from "waterwheel"
  import jsonapiParse from "jsonapi-parse";

  const waterwheel = new Waterwheel(
      {
        base: process.env.VUE_APP_HOST_URL,
        jsonapiPrefix: 'api',
        timeout: 3000,
        accessCheck: false
      }
  );
  export default {
    name: 'Module',
    props: {
      module: Object,
      type: String,
    },
    data() {
      return {
        moduleComponent: null,
        loadedModule: [],
      }
    },

    computed: {
      loader() {
        let type = this.type;
        type = type.replace(/paragraph--/, '');

        if (!this.type) {
          return null
        }
        return () => import(`./modules/${type}`)
      },
    },
    created() {

      let type = this.module.type;
      type = type.replace(/paragraph--/, '');
      //import(`./modules/${type}`);
      let getRequestUrl = 'paragraph/' + type + '/' + this.module.id;
      let query = '';
      if (type==='classico') {
        query = {
          include: 'immagine, moduli, moduli.file',
        }
      }
      if (type==='aziende') {
        query = {
          include: 'aziende, aziende.logo',
        }
      }
      if (type==='animation') {
        query = {
          include: 'file',
        }
      }
      if (type==='icone') {
        query = {
          include: 'icone, icone.icona',
        }
      }
      waterwheel.jsonapi.get(getRequestUrl, query).then(loadedModule => {
        this.loadedModule = jsonapiParse.parse(loadedModule).data;
      })
          .catch(error => console.log('error on getModule: ', error))
          .finally(() => {
            this.moduleComponent = () => this.loader();
            this.loading = false;
          });
    },
  }
</script>
